module.exports = {
  // can't end in backslashes if you must append a dynamic variable add it in the endpoint creation via concatenation
  productTypeSvc: '/rmd-service-auto/api/agreements/products',
  personalInformationEndpoint: '/rmd-service-auto/api/entity/details',
  relationshipManager: '/rel-mgr-service-api/api/client-relationship/bio/rm',
  existingBanksEndpoint: `/rmd-service-auto/api/agreements/banks/ach?transactionType=AutomaticTransactions`,
  userFunds:
    '/rmd-service-auto/api/agreements/display/information?productType=MUTUAL_FUND',
  // agreementMap: `/self-serve-service-api/service/banking/bank-agreements/association`,
  agreementMap: `/rmd-service-auto/api/agreements/bank-agreements/association`,
  automaticSell: `/rmd-service-auto/api/agreements/recurring?transactionType=Redeem`,
  automaticExchange: `/rmd-service-auto/api/agreements/recurring?transactionType=Exchange`,
  stateWithholding: `/self-serve-service-api/service/stateWitholding`,
  systematics: '/self-serve-service-api/service/systematics',
  recentTransactions: `/rmd-service-auto/api/transactions/history`,
  estimateDateEndPoint: `/self-serve-service-api/service/systematic/commencement`,
  customerInfo: `/rmd-service-auto/api/customer/loggedin`,
  rmdMinimumDistribution:
    '/rmd-service-auto/api/projected/required-minimum-distribution',
  RMDEndpoint: '/rmd-service-auto/api/rmd-summary-plus',
  allFunds: '/self-serve-service-api/service/agreements/fund-list',
  existingRMDEndpoint: '/rmd-service-auto/api/rmdSchedule',
  submitRMDapi: '/rmd-service-auto/api/schedule-rmd',
  exchangeToExistingSearch: `/rmd-service-auto/api/exchange/eligible-agreements/exchange-to-existing/search`,
  getMessages: '/accountaccess-msg-svc/api/inbox-summary',
  getQCDHistory: '/self-serve-service-api/service/qcd/history',
  getQCDPDF: '/self-serve-service-api/service/qcd/on-demand/pdf',

   //User communication service
   paperlessTermsAndConditions: '/personal-investing/terms-and-conditions/paperless.model.json'
};
